import React from "react";
import { Stack } from "@UI/Components/Stack/Stack";
import { Box } from "@UI/Components/Box/Box";
import { Drawer } from "@UI/Components/Drawer/Drawer";
import useMediaQuery from "@UI/hooks/useMediaQuery";
import { ServiceOfferDescription } from "@modules/ServiceAssignment/Components/ServiceOfferDescription/ServiceOfferDescription";
import { Button } from "@UI/Components/Button/Button";
import { CandidateProfileSection } from "./CandidatesSection/CandidateProfileSection";
import { CandidateAvatar } from "./CandidatesSection/CandidateAvatar";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "./messages";
import { ICandidateOfferModalProps } from "../types";
import { useServiceOffer } from "@modules/ServiceAssignment/hooks/useServiceOffer";

export const CandidateOfferModal = (props: ICandidateOfferModalProps) => {
  const { isOpen, onClose, candidate, onDeclineOfferModalOpen } = props;
  const { isDesktop } = useMediaQuery();

  const serviceOfferId = candidate?.serviceOffer?.id;

  const { serviceOffer } = useServiceOffer(serviceOfferId);

  const handleSelectOffer = () => {
    if (window)
      window.location.href = `/contracts/${serviceOfferId}/subscription_fee/new?id=${serviceOfferId}`;
  };

  const handleDeclineOffer = () => {
    onClose();
    onDeclineOfferModalOpen(candidate?.conversationId);
  };

  return (
    <Drawer
      placement={isDesktop ? "right" : "bottom"}
      onClose={onClose}
      isOpen={isOpen}
      size="lg"
      drawerContentContainerStyle={{
        borderRadius: !isDesktop ? "1.25rem" : "none",
        borderBottomRadius: "none",
      }}
    >
      <Stack
        justifyContent="space-between"
        height="full"
        p={{ base: 0, md: 4 }}
      >
        <Box
          as="button"
          w="fit-content"
          data-bs-toggle="offcanvas"
          data-bs-target={`#offcanvas-profil-sp-${candidate?.id}`}
          aria-controls="offcanvasRight"
          onClick={onClose}
        >
          <CandidateProfileSection
            {...candidate}
            superTalent={false}
            showSeeProfileText={true}
            profileNameStyle={{
              fontSize: "1.125rem",
              lineHeight: { base: "24px", lg: "27px" },
            }}
            badgeStyle={{ fontSize: "0.75rem" }}
            ratingStyle={{ fontSize: "1rem" }}
            avatarSection={
              <CandidateAvatar
                size="s"
                url={candidate?.profilePicture}
                isSuperTalent={candidate?.superTalent}
              />
            }
          />
        </Box>

        <ServiceOfferDescription
          serviceOfferId={serviceOffer?.id}
          showServiceFees={false}
          showAdvancePayment={false}
        />
        <Stack direction="row">
          <Button
            size="lg"
            px="22px"
            background="transparent"
            border="1px"
            borderColor="gray.300"
            minW="fit-content"
            onClick={handleDeclineOffer}
          >
            <FormattedMessage {...messages["serviceRequest.decline"]} />
          </Button>
          <Button
            data-testid="accept-application"
            as="button"
            w="full"
            size="lg"
            colorScheme="seaGreen"
            flexGrow="1"
            onClick={handleSelectOffer}
          >
            <FormattedMessage
              {...messages["serviceRequest.selectServiceProviderOffer"]}
              values={{ serviceProviderName: candidate?.firstName }}
            />
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
};
